import { render, staticRenderFns } from "./SpecimenLocationsModal.vue?vue&type=template&id=93c7904e&scoped=true"
import script from "./SpecimenLocationsModal.vue?vue&type=script&lang=js"
export * from "./SpecimenLocationsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93c7904e",
  null
  
)

export default component.exports